import UAParser from 'ua-parser-js';
import { IWindow } from '../Window';

export function getOperatingSystem(window: IWindow) {
  const userAgent = window.navigator.userAgent;
  const parser = new UAParser(userAgent);

  return parser.getOS();
}
